/**
 * AI provider keys and types used across the platform.
 * These values are used for user-owned API key configuration.
 */
// Keep this union minimal and extensible; only include supported providers
export const AI_PROVIDERS = [
    'openai',
    'anthropic',
    'google',
    'azure_openai',
];
// Map provider to backend API relative endpoint for chat invocations
export const AI_PROVIDER_CHAT_ENDPOINT = {
    openai: '/api/ai/openai/chat',
    anthropic: '/api/ai/anthropic/chat',
    google: '/api/ai/google/chat',
    azure_openai: '/api/ai/azure-openai/chat',
};
